import { render } from "./HighlightStaticSkeleton.vue?vue&type=template&id=d3c8862a&scoped=true&ts=true"
import script from "./HighlightStaticSkeleton.vue?vue&type=script&lang=ts"
export * from "./HighlightStaticSkeleton.vue?vue&type=script&lang=ts"

import "./HighlightStaticSkeleton.vue?vue&type=style&index=0&id=d3c8862a&scoped=true&lang=css"

import exportComponent from "/var/www/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3c8862a"]])

export default __exports__